<template>
  <popup
    :class="['rb-popup-static', data.popup_id]"
    :title="data.title"
    :active="active"
    :on-screen="onScreen"
    @close="close"
  >
    <div class="rb-center">
      <popup-content-guide :data="data" v-if="data.type === 'popup_guides'" />
      <popup-content-text :data="data" v-if="data.type === 'popup_text'" />
      <popup-content-intro-img-outro
        :data="data"
        v-if="data.type === 'popup_intro_image_outro'"
      />
      <popup-content-intro-text
        :data="data"
        v-if="data.type === 'popup_intro_text'"
      />
      <popup-content-intro-title-img
        :data="data"
        v-if="data.type === 'popup_intro_title_image'"
      />
      <popup-content-text-links
        :data="data"
        v-if="data.type === 'popup_text_links'"
      />
    </div>
  </popup>
</template>

<script>
/**
 * Popup wrapper for static popups generated via customizer
 *
 * @props
 * data: Object
 *
 * @implements
 * PopupMixin
 * CommMixin
 */
import CommMixin from "@/mixins/CommMixin";
import Popup from "@/components/Popup";
import PopupMixin from "@/mixins/PopupMixin";
import PopupContentGuide from "@/components/PopupContentGuide";
import PopupContentIntroText from "@/components/PopupContentIntroText";
import PopupContentIntroImgOutro from "@/components/PopupContentIntroImgOutro";
import PopupContentIntroTitleImg from "@/components/PopupContentIntroTitleImg";
import PopupContentText from "@/components/PopupContentText";
import PopupContentTextLinks from "@/components/PopupContentTextLinks";
export default {
  components: {
    Popup,
    PopupContentGuide,
    PopupContentIntroText,
    PopupContentIntroImgOutro,
    PopupContentIntroTitleImg,
    PopupContentText,
    PopupContentTextLinks,
  },
  mixins: [PopupMixin, CommMixin],
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
